module.exports = __webpack_public_path__ + "media/images/pages/fausto_botelho_main_pic-5e4d1c40c7f6c3a0015bd29009f8d4ef.png";